'use strict';

function createLocalDate(year, monthIndex, date = 1, hours = 0, minutes = 0, seconds = 0, ms = 0) {
  return new Date(year, monthIndex, date, hours, minutes, seconds, ms);
}

module.exports = createLocalDate;
//# sourceMappingURL=createLocalDate.cjs.map
